import axios from '@/plugins/axios.js';

export function save(params) {
    return axios.post("mp/product/save", params);
}

export function remove(id) {
    return axios.delete("mp/product/" + id);
}

export function update(params) {
    return axios.post("mp/product/update", params);
}

export function list(params) {
    return axios.get("mp/product/list", { params: params });
}

export function detail(id){
    return axios.get(`mp/product/detail?id=${id}`);
}